import {
  EditFRDStartRegistrationTask,
  FRDStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickFrdLibraryFields } from "../../../schema/frd-schema-library";

const sharedTitle = (type: FormType | undefined) => `FRD-StartRegistratie ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het FRD StartRegistratie formulier. ${getDocsLinkMarkdown(
  "FRD"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  required: ["objectIdAccountableParty", "gmwBroId", "tubeNumber"],
  properties: pickFrdLibraryFields([
    "objectIdAccountableParty",
    "gmwBroId",
    "tubeNumber",
    "groundwaterMonitoringNets",
  ]),
};

const getFrdStartRegistrationCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<FRDStartRegistrationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "qualityRegime", "deliveryAccountableParty"],
      properties: pickFrdLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getFrdStartRegistrationEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditFRDStartRegistrationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickFrdLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickFrdLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getFrdStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditFRDStartRegistrationTask>;
export function getFrdStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<FRDStartRegistrationTask>;
export function getFrdStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditFRDStartRegistrationTask> | SchemaForFormData<FRDStartRegistrationTask>;
export function getFrdStartRegistrationSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing
    ? getFrdStartRegistrationEditSchema(type)
    : getFrdStartRegistrationCreateSchema(type);
}
